import React, { useEffect, useState } from 'react';
import * as Yup from 'yup';
import {
	Box,
	Button,
	Select,
	FormLabel,
	Text,
} from '@chakra-ui/react'
import { InputText, Form } from '../../components/form'
import { toast } from "react-toastify";
import { fetchWrapper } from '../../helpers';
import { Field } from 'formik';

function Create({ meClose, loadList, customer_id }) {



	const [formData, setFormData] = useState({
		username: '',
		email: '',
		password: '',
		confirm_password: '',
		customer_id: customer_id,
		role_id: '',
		data_access: '',
	});


	const [roles, setRoles] = useState([]);
	const [rolesError, setRolesError] = useState('');

	useEffect(() => {
		const loadRoles = async () => {
			try {
				const url = `${process.env.REACT_APP_API_URL}/roles/list`;
				const res = await fetchWrapper.get(url);
				setRoles(res?.data || []);
			} catch (err) {
				// RP_003: /roles/list can 403 for a user who has user-create but not
				// roles access — keep the form open and say why the dropdown is empty.
				console.error(err);
				setRolesError("Couldn't load roles. You may not have access to view roles — ask your admin.");
			}
		};
		loadRoles();
	}, []);

	const FormSchema = Yup.object().shape({
		username: Yup.string().required('Required'),
		email: Yup.string()
			.email('Invalid email address')
			.required('Email is required'),

		password: Yup.string()
			.min(8, 'Password must be at least 8 characters')
			.matches(/\d/, 'Password must contain at least one digit')
			.matches(/[a-zA-Z]/, 'Password must contain at least one letter')
			.matches(/[!@#$%^&*(),.?":{}|<>]/, 'Password must contain at least one special character')
			.required('Password is required'),
		confirm_password: Yup.string()
			.oneOf([Yup.ref('password'), null], 'Passwords must match')
			.required('Required'),

	});








	const onSubmit = async (values, { setSubmitting, resetForm, setStatus }) => {

		let data = values;
		delete data.confirm_password;

		const url = `${process.env.REACT_APP_API_URL}/user/create`;
		try {
			await fetchWrapper.post(url, data)
		} catch (err) {
			toast(typeof err === 'string' ? err : 'Failed to create user', { type: "error" });
			return;
		}
		loadList()
		meClose();
		toast(`Record has been saved `, {
			type: "info"
		});
	}

	return (
		<>

			<Form
				enableReinitialize
				validationSchema={FormSchema}
				initialValues={formData}
				onSubmit={onSubmit}
			>

				<Box mb="10px">
					<InputText name="username" title="Full Name" inputProps={{ isRequired: true }} />
				</Box>
				<Box mb="10px">
					<InputText name="email" title="Email" inputProps={{ isRequired: true }} />
				</Box>
				<Box mb="10px">
					<InputText name="password" title="Password" inputProps={{ type: 'password', isRequired: true }} />
				</Box>

				<Box mb="10px">
					<InputText name="confirm_password" title="Confirm Password" inputProps={{ type: 'password', isRequired: true }} /> {/* Confirm password field */}
				</Box>



				<Box mb="10px">
					<FormLabel fontSize="14px" mb="4px">Role</FormLabel>
					<Field name="role_id">
						{({ field }) => (
							<Select {...field} placeholder="Select Role">
								{roles.map((role) => (
									<option key={role.id} value={role.id}>
										{role.name}
									</option>
								))}
							</Select>
						)}
					</Field>
					{rolesError && (
						<Text fontSize="xs" color="red.500" mt={1}>{rolesError}</Text>
					)}
				</Box>

				<Box mb="10px">
					<FormLabel fontSize="14px" mb="4px">Data Access</FormLabel>
					<Field name="data_access">
						{({ field }) => (
							<Select {...field} placeholder="Select Data Access">
								<option value="A">All</option>
								<option value="O">Own</option>
							</Select>
						)}
					</Field>
				</Box>


				<Button className='custom-chakra-button' py="10px" px="25px" colorScheme="white" background={"var(--brand-primary)"} fontSize="14px" fontWeight="500" fontFamily="'Lato', sans-serif"
					mb={4}

					type='submit'
				>
					Add New User
				</Button>
			</Form>

		</>
	)
}

export default Create;